import { render } from "./ConfirmationTab.vue?vue&type=template&id=76e0fd35&scoped=true"
import script from "./ConfirmationTab.vue?vue&type=script&lang=js"
export * from "./ConfirmationTab.vue?vue&type=script&lang=js"

import "./ConfirmationTab.vue?vue&type=style&index=0&id=76e0fd35&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e0fd35"]])

export default __exports__